import { ConfirmModal } from '@sparklayer-io/spark-dash-ui/components/confirm-modal';
import { t } from 'i18next';
import { I18N_COMPONENTS } from '../constants';

export function RemovePriceListModal({
  slug,
  isOpen,
  onClose,
  onConfirm,
  loading,
}: {
  slug: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}) {
  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      title={t(`${I18N_COMPONENTS}.remove_price_list_modal.title`)}
      confirmText={t(`${I18N_COMPONENTS}.remove_price_list_modal.confirm`)}
      message={t(`${I18N_COMPONENTS}.remove_price_list_modal.message`, { slug })}
    />
  );
}
